import session from './session';

export default {
  getModObj(cv_id) {
    console.log('****getModOb: ' + cv_id);
    return session.get('/api/' + cv_id + '/layout/' + cv_id + '/');
  },
  updateModObj(cv_id, data) {
    console.log('****getModOb: ' + cv_id);
    return session.put('/api/' + cv_id + '/layout/' + cv_id + '/', data);
  },

  // API CV
  getCvObj(cvid) {
    console.log('****getCvObj: ' + cvid);
    return session.get('/api/cv/' + cvid + '/');
  },
  patchCvObj(cvid, data) {
    console.log('****getCvObj: ' + cvid);
    return session.patch('/api/cv/' + cvid + '/',  data);
  },
};
